import React, {Fragment} from 'react'

export default function PartImage(props) {
    let part = props.parts;

    let image_path = part['media']['main_image']['path'];
    let image_width = part['image_width'] === 0? "100%": `${part['image_width']}px`;
    let image_height = part['image_height'] === 0? "auto": `${part['image_height']}px`;
    let image_style = {width: image_width, minWidth: image_width, height: image_height};
    let image_size = 'cover';

    if(part['image_adjust'] === 'true'){
        image_size = 'contain';
    }

    if (part['image_width'] === 0 && part['image_height'] === 0) {
        image_size = 'static';
    } else {
        if (part['image_height'] === 0) {
            image_size = "static";
        }
        image_width = part['image_width'] === 0? "100%": `${part['image_width']}px`;
        image_height = part['image_height'] === 0? "auto": `${part['image_height']}px`;
        image_style = {width: image_width, minWidth: image_width, height: image_height};
    }


    return (
        <Fragment>
            {
                part['content'] && 
                    <div className="text-block">
                        <div className="text">
                            <div dangerouslySetInnerHTML={{__html: part['content']}} />
                        </div>
                    </div>
            }
            <div className="flex">
                <div className= {`image ${image_size}`} {...image_style}>
                    <img src={image_path} alt={part['media']['main_image']['alt']} title={part['media']['main_image']['title']} />
                </div>
            </div>
        
        </Fragment>
    )
}



    